/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "studybuddyPaypal",
            "endpoint": "https://45j5dipq78.execute-api.us-west-2.amazonaws.com/stage",
            "region": "us-west-2"
        },
        {
            "name": "studybuddyapi",
            "endpoint": "https://1a7oz6ioq2.execute-api.us-west-2.amazonaws.com/stage",
            "region": "us-west-2"
        },
        {
            "name": "studybuddystripewebhooks",
            "endpoint": "https://8ipd256nob.execute-api.us-west-2.amazonaws.com/stage",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:e2aad067-93fb-40a3-85a9-6bfb5e24d77d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_qi7Mtag2T",
    "aws_user_pools_web_client_id": "72ugehtcu4mai7n46r0vud5nc2",
    "oauth": {
        "domain": "studybuddy22a29284-22a29284-stage.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/signin-redirect/,https://studybuddy.gg/signin-redirect/,https://stage.d1y0i8lb7zac9d.amplifyapp.com/signin-redirect/",
        "redirectSignOut": "http://localhost:3000/signout-redirect/,https://studybuddy.gg/signout-redirect/,https://stage.d1y0i8lb7zac9d.amplifyapp.com/signout-redirect/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "CancellationRequestsDB-stage",
            "region": "us-west-2"
        },
        {
            "tableName": "UserActivity-stage",
            "region": "us-west-2"
        },
        {
            "tableName": "db-questions-table-stage",
            "region": "us-west-2"
        },
        {
            "tableName": "submissions-stage",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
